import React from 'react'
import Navbar from '../inc/Navbar'
import Logo from "../images/logo _koffee.png";
import { Link } from "react-router-dom";
import Map from "./Map";
import aboutuskoffeehouse from "../images/about us _koffee.jpeg";
import "./Home.css";
import Slider from '../inc/Slider';
import About from './About';
import selfitime from "../images/selfi time.jpeg";
import Food from './Food';
import ScrollToTop from "react-scroll-to-top";
import Gallery from './Gallery';
import selfitimekoffee from "../images/selfi time_Koffee House.jpeg";
import selfitimekoffeehouse from "../images/selfi.jpeg";
import selfitimekoffeephoto from "../images/selfi-koffee.jpeg"
function Home() {
    return (
        <div>
            <Navbar />
            <br />
            <br />
            <br />
            <br />

            <div className="nadia_coffee">
                <div className="album py-2">
                    <div className="container">
                        <div className="row ">
                            <div className="col-md-2">
                                <center>
                                    <Link to="/">
                                        <img src={Logo} className='mt-1 logokps' width="150px" height="150px" alt="kps logo" />

                                    </Link>

                                </center>
                            </div>
                            <div className="col-md-8">
                                <center>

                                    <h1 style={{ color: "white" }} className='font mb-0 mt-3'><b>KOFFEE HOUSE</b></h1>
                                    <div className='fonts'>
                                        <p style={{ color: "white" }} className='mb-2'>Family Restaurant | ESTD: 2005</p>

                                        <h6 style={{ color: "white" }} className='mb-0' >2/1 M.M.Ghosh Street, Foura More, Krishnagar City, 741101 | WB | India</h6>

                                    </div>

                                </center>
                            </div>


                            <div className="d-flex justify-content-between align-items-center">

                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Slider />
            <div className='familyrestaurant'>
                <div className="album py-2">
                    <div className="container">
                        <div className="row">
                            <marquee>
                                <h5 style={{ color: "white" }}><b>Welcome to Koffee House – Experience Hygienic Dining at the Best Family Restaurant in Krishnagar</b></h5>
                            </marquee>
                        </div>
                    </div>
                </div>


            </div>
            <br />
            <div className="album py-2">
                <div className="container">
                    <div className="row">
                        <div className="col-md-6 mt-3">
                            <h1 className='mb-2'>About <b style={{ color: "#3D2219" }}> Koffee House</b></h1>
                            <p className="card-text">Welcome to <b> Koffee House</b>, a popular family restaurant in Krishnagar, Nadia, known for serving delicious, hygienic, and freshly prepared food in a comfortable and friendly environment. We are proud to be one of the best restaurants in Krishnagar where families, friends, and food lovers come together to enjoy quality meals and great service.</p>
                            <p>At Koffee House, our goal is to provide a perfect dining experience with a wide range of tasty dishes prepared using high-quality ingredients and strict hygiene standards. Our menu offers a variety of Indian food, Chinese cuisine, fast food, snacks, coffee, and beverages, making us a favorite restaurant and coffee spot in Krishnagar for people of all ages.</p>
                            <div className="d-flex justify-content-end align-items-end mb-0">
                                <a href='aboutus'>
                                    <button className='foodcourtkrishnagar mt-1'>Read More <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                                        <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                                    </svg></button>
                                </a>
                            </div>
                        </div>
                        <div className="col-md-6 mt-3">
                            <img src={aboutuskoffeehouse} className="card-img-top" alt="aboutuskoffeehouse" />

                        </div>
                    </div>
                </div>


            </div>
            <br/>
                <Food />
                <br/>

     <ScrollToTop smooth top="100" color="maroon" />
            <div className='back'>
                <br />
                <div className="album py-0">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-5">
                                <h1>Koffee House <b style={{ color: "#74260c" }}> Selfi Time</b></h1>
                                <hr />

                            </div>
                        </div>
                    </div>
                </div>

                <div className="album py-0">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-6 mt-3">
                                <img src={selfitime} className="card-img-top" alt="selfitime" />

                            </div>
                            <div className="col-md-6 mt-3">
                                <img src={selfitimekoffee} className="card-img-top" alt="selfitime" />

                            </div>
                            <div className="col-md-6 mt-3">
                                <img src={selfitimekoffeehouse} className="card-img-top" alt="selfitime" />

                            </div>
                            <div className="col-md-6 mt-3">
                                <img src={selfitimekoffeephoto} className="card-img-top" alt="selfitime" />

                            </div>
                        </div>
                    </div>
                </div>
                <br />
                <br />
            </div>
            <div className="album py-2">
                <div className="container">
                    <div className="row">
                        <div className="col-md-6 mt-3">
                            <iframe src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2Fkoffeehousenadia%2F&tabs=timeline&width=1000&height=500&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true&appId" width="100%" height="500" scrolling="no" frameborder="0" allowfullscreen="true" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"></iframe>
                        </div>
                        <div className="col-md-6 mt-3">
                            <iframe src="https://www.facebook.com/plugins/video.php?height=314&href=https%3A%2F%2Fwww.facebook.com%2Freel%2F1916260902265710%2F&show_text=true&width=500&t=0" width="100%" height="500" scrolling="no" frameborder="0" allowfullscreen="true" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share" allowFullScreen="true"></iframe>

                        </div>
                    </div>
                </div>
            </div>
            <br/>
     <div className="album py-0">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-5">
                                <h1>Koffee House <b style={{ color: "#74260c" }}> Gallery</b></h1>
                                <hr />

                            </div>
                        </div>
                    </div>
                </div>

            <Gallery/>
            <br/>
            <Map />
        
            <br/>
        </div>
    )
}

export default Home